module.exports = __webpack_public_path__ + "images/punkt_kolo.png?390797e799ecd80ecd42121454d35a31";